import { Button, Grid, MobileStepper, Modal, Slide, Typography } from '@mui/material'
import { useContext, useState } from 'react'
import { ToolContext } from '../../../core/context/ToolContext'
import { Box } from '@mui/system'
import { useHistory } from 'react-router-dom/cjs/react-router-dom'
import { useTheme } from '@mui/styles'
import PointingIMG from '../../../assets/images/core/pointing_img.png'
import AddBranchIMG from '../../../assets/images/core/addbranch.png'
import CodesIMG from '../../../assets/images/core/code.png'
import ExportCodesIMG from '../../../assets/images/core/export_codes.png'
import CodesListIMG from '../../../assets/images/core/codelist.png'
import SendingPointsIMG from '../../../assets/images/core/sending_points.png'
import ContentIMG from '../../../assets/images/core/content_img.png'
import StyleIMG from '../../../assets/images/core/styles_img.png'
import DetailsIMG from '../../../assets/images/core/details_img.png'


export const ModalPromoMsg = () => {
    const { tool_state, ubr_state } = useContext(ToolContext)
    const { modal_promo, modal_lty, modal_bkg } = { ...tool_state, ...ubr_state };
    const history = useHistory()

    const handlerEvent = (t) => {
        console.log(t)
        if (t === "booking_service") {
            modal_bkg.set(true)
            modal_promo.set(false)
            history.push(`promo?type=service&service_type=attract`)
        } if (t === "loyalty_promo") {
            modal_lty.set(true)
            modal_promo.set(false)
            history.push(`program?type=point`)
        } if (t === "product_promo") {
            history.push(`promo?type=product&option=attract`)
        }
        if (t === "sales_page") {
            history.push(`sales_page?type=property&option=attract`)
        }
    }

    const theme = useTheme();
    const [activeStep, setActiveStep] = useState(0);
    const [bkgStep, setBkgStep] = useState(0);

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1)
        if (activeStep === 5) {
            modal_lty.set(false)
        }
    };
    const handleBack = () => { setActiveStep((prevActiveStep) => prevActiveStep - 1) };
    const Next = () => { setBkgStep((prevActiveStep) => prevActiveStep + 1) };
    const Back = () => { setBkgStep((prevActiveStep) => prevActiveStep - 1) };
    return (
        <>
            <Modal open={modal_promo.data}>
                <Slide in={modal_promo.data} direction='up'>
                    <Box height="100%" width="100%" display="flex" flexDirection="column" alignItems="center" justifyContent="center" mt={4}>
                        <Box position="relative" bgcolor="#fff" width="900px" p={3} borderRadius={2} display="flex" flexDirection="column" justifyContent="center">
                            <Box mb={3} fontSize={20} fontWeight={700} textAlign="center">Welcome to HRC.</Box>
                            <Box mb={3} fontSize={16} fontWeight={600} textAlign="center">What would you like to do?</Box>
                            <Grid container spacing={2} >
                                <ModalFeature title="Create a booking promo page utilizing the provide template designed for services such as campsites,hotels, and similar accommodations." btn="Create Booking Promo Page" event={() => handlerEvent('booking_service')} />
                                <ModalFeature title="Create a product promo page utilizing the provided template designed for product promotion and selling." btn="Create Product Promo Page" event={() => handlerEvent('product_promo')} />
                                <ModalFeature title="Establish a reward system for your product or service, enabling your customers to accumulate points with each purchase, which can later be redeemed once a specified points reached." btn="Create Loyalty Program" event={() => handlerEvent('loyalty_promo')} />
                                <ModalFeature title="Unlock the potential of our customizable template to showcase your condominium, house, or rental room. Craft compelling property pages that captivate potential tenants or buyers with ease." btn="Create Real Property Page" event={() => handlerEvent('sales_page')} />
                            </Grid>
                        </Box>
                    </Box>
                </Slide>
            </Modal>

            <Modal open={modal_lty.data}>
                <Slide in={modal_lty.data} direction='up'>
                    <Box height="100%" width="100%" display="flex" flexDirection="column" alignItems="center" justifyContent="center" mt={4}>
                        <Box position="relative" bgcolor="#fff" width="50%" p={4} borderRadius={2} display="flex" flexDirection="column" justifyContent="center">
                            <Box width="100%" display="flex" justifyContent="center" p={3} bgcolor="gray" flexDirection="column">
                                <Typography fontSize={18} fontWeight={700}>Steps to Set Your Loyalty Program</Typography>

                                {
                                    activeStep === 0 &&
                                    <Box>
                                        <Box py={4}>1. Setup product you want to add points.</Box>
                                        <Box><img src={PointingIMG} style={{ width: "100%" }} alt={PointingIMG} /></Box>
                                    </Box>
                                }
                                {
                                    activeStep === 1 &&
                                    <Box>
                                        <Box py={4}>2. Setup your store branch (if none set your main branch)</Box>
                                        <Box><img src={AddBranchIMG} style={{ width: "100%" }} alt={AddBranchIMG} /></Box>
                                    </Box>
                                }
                                {
                                    activeStep === 2 &&
                                    <Box>
                                        <Box py={4}>3. Generate code for your branch for specific date.</Box>
                                        <Box><img src={CodesIMG} style={{ width: "100%" }} alt={CodesIMG} /></Box>
                                    </Box>
                                }
                                {
                                    activeStep === 3 &&
                                    <Box>
                                        <Box py={4}>4. Export your code (Use this in your branch, let your customer list the details need as they buy.)</Box>
                                        <Box><img src={ExportCodesIMG} style={{ width: "100%" }} alt={ExportCodesIMG} /></Box>
                                    </Box>
                                }
                                {
                                    activeStep === 4 &&
                                    <Box>
                                        <Box py={4}>5. Collect the list and encode in the system.</Box>
                                        <Box><img src={CodesListIMG} style={{ width: "100%" }} alt={CodesListIMG} /></Box>
                                    </Box>}
                                {
                                    activeStep === 5 &&
                                    <Box>
                                        <Box py={4}>6. Send points to the customer.</Box>
                                        <Box><img src={SendingPointsIMG} style={{ width: "100%" }} alt={SendingPointsIMG} /></Box>
                                    </Box>
                                }
                                {activeStep === 6 && modal_lty.set(false)}

                            </Box>

                            <MobileStepper variant='dots' steps={6} position="static" activeStep={activeStep} sx={{ display: "flex", alignItems: "center", justifyContent: "center", bgcolor: "#fff", py: 4 }} />

                            <Box width="100%" display="flex" alignItems="center" justifyContent="center" gap={3}>
                                {theme.direction === 'rtl' ?
                                    <Button variant='contained' onClick={() => handleNext()} disabled={activeStep === 6} sx={{ width: 200, height: 49, ":hover": { bgcolor: "green", color: "#fff" } }}>Next</Button>
                                    :
                                    <Button variant='contained' onClick={handleBack} disabled={activeStep === 0} sx={{ width: 200, height: 49, ":hover": { bgcolor: "green", color: "#fff" } }}>Back</Button>
                                }
                                {
                                    theme.direction === 'rtl' ?
                                        <Button variant='contained' onClick={handleBack} disabled={activeStep === 0} sx={{ width: 200, height: 49, ":hover": { bgcolor: "green", color: "#fff" } }}>Back</Button>
                                        :
                                        <Button variant='contained' onClick={() => handleNext()} disabled={activeStep === 6} sx={{ width: 200, height: 49, ":hover": { bgcolor: "green", color: "#fff" } }}>Next</Button>
                                }
                            </Box>
                        </Box>
                    </Box>
                </Slide>
            </Modal>

            <Modal open={modal_bkg.data}>
                <Slide in={modal_bkg.data} direction='up'>
                    <Box height="100%" width="100%" display="flex" flexDirection="column" alignItems="center" justifyContent="center" mt={4}>
                        <Box position="relative" bgcolor="#fff" width="50%" p={4} borderRadius={2} display="flex" flexDirection="column" justifyContent="center">
                            <Box width="100%" display="flex" justifyContent="center" px={3} bgcolor="gray" flexDirection="column">
                                <Box mt={4}>
                                    {
                                        bkgStep === 0 &&
                                        <Box>
                                            <Typography fontSize={18} fontWeight={700}>This is the section where you can customize the content of the Promo Page specifically tailored to highlight your booking service promo. </Typography>
                                            <Box mt={3}><img src={ContentIMG} style={{ width: "100%" }} alt={ContentIMG} /></Box>
                                        </Box>
                                    }

                                    {
                                        bkgStep === 1 &&
                                        <Box>
                                            <Typography fontSize={18} fontWeight={700}>This is the section where you can customize the design of Promo Page specifically tailored to highlight your booking service promo. </Typography>
                                            <Box mt={3}><img src={StyleIMG} style={{ width: "100%" }} alt={StyleIMG} /></Box>
                                        </Box>
                                    }

                                    {
                                        bkgStep === 2 &&
                                        <Box>
                                            <Typography fontSize={18} fontWeight={700}>This is the section where you can input the details of your Promo Page that is necessary for the completeness of your promo. </Typography>
                                            <Box mt={3}><img src={DetailsIMG} style={{ width: "100%" }} alt={DetailsIMG} /></Box>
                                        </Box>
                                    }
                                    {bkgStep === 3 &&
                                        modal_bkg.set(false)
                                    }
                                </Box>
                            </Box>

                            <MobileStepper variant='dots' steps={3} position="static" activeStep={bkgStep} sx={{ display: "flex", alignItems: "center", justifyContent: "center", bgcolor: "#fff", py: 4 }} />

                            <Box width="100%" display="flex" alignItems="center" justifyContent="center" gap={3}>
                                {theme.direction === 'rtl' ?
                                    <Button variant='contained' onClick={() => Next()} disabled={bkgStep === 3} sx={{ width: 200, height: 49, ":hover": { bgcolor: "green", color: "#fff" } }}>Next</Button>
                                    :
                                    <Button variant='contained' onClick={Back} disabled={bkgStep === 0} sx={{ width: 200, height: 49, ":hover": { bgcolor: "green", color: "#fff" } }}>Back</Button>
                                }
                                {theme.direction === 'rtl' ?
                                    <Button variant='contained' onClick={Back} disabled={bkgStep === 0} sx={{ width: 200, height: 49, ":hover": { bgcolor: "green", color: "#fff" } }}>Back</Button>
                                    :
                                    <Button variant='contained' onClick={() => Next()} disabled={bkgStep === 3} sx={{ width: 200, height: 49, ":hover": { bgcolor: "green", color: "#fff" } }}>Next</Button>
                                }
                            </Box>
                        </Box>
                    </Box>
                </Slide>
            </Modal>

        </>
    )
}


export const ModalFeature = ({ title, btn, event }) => {

    return (
        <Grid item xs={4}>
            <Box width="100%" height={300} bgcolor="green" display="flex" flexDirection="column" alignItems="center" p={3} gap={2}>
                <Typography height="100%" fontSize={14} color="#fff">{title}</Typography>
                <Button sx={{ height: 50, width: "100%", mb: 1, bgcolor: "#fff", py: 4, px: 2, fontWeight: 600, ":hover": { bgcolor: "#fff" } }} onClick={event}>{btn}</Button>
            </Box>
        </Grid>
    )
}